require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-wird-gezimmert.json") })
        }
      }, "path---es-wird-gezimmert");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-wird-gezimmert!./.cache/json/es-wird-gezimmert.json
// module id = 424
// module chunks = 231608221292675